import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { SingleDatePicker, Icons, Button, TYPES } from 'sarsaparilla';
import moment from 'moment';
import { INYO_NF_PERMIT_ID, OVERNIGHT_PERMIT, QUESTIONAIRE_RESULTS_ENUM } from '../../utils/inyoUtils';
import * as utils from '../../utils/availabilityUtils';
import { AVAILABILITY_KEY_MAP_FORMAT } from '../../constants';

class InyoNFOvernightPermit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
      date: null,
      isDisabled: true,
      dateWhithinSeason: null,
      moreThankSixMonthAway: null
    };
    this.setPermitType = this.setPermitType.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
  }

  onDateChange(date) {
    this.setState({ date });
    const monthsAway = date.diff(moment().utc().startOf('day'), 'month');
    const dateWhithinSeason = utils.isDayWithinSeason(date, { permit: this.props.permit });
    const isDisabled = (dateWhithinSeason === false || monthsAway >= 6);
    this.setState({
      isDisabled,
      dateWhithinSeason,
      moreThankSixMonthAway: monthsAway >= 6
    });
  }

  setPermitType() {
    if (this.state.dateWhithinSeason === true && this.state.moreThankSixMonthAway === false) {
      this.props.history.push(`/permits/${INYO_NF_PERMIT_ID}/registration/detailed-availability?type=${OVERNIGHT_PERMIT}&date=${this.state.date.format(AVAILABILITY_KEY_MAP_FORMAT)}`);
    }
  }

  getSingleDatePickerFormElementProps() {
    return {
      id: "SingleDatePicker2",
      date: this.state.date,
      numberOfMonths: 1,
      focused: this.state.focused,
      showDefaultInputIcon: true,
      onDateChange: this.onDateChange,
      onFocusChange: ({ focused }) => this.setState({ focused })
    };
  }

  render() {
    let result = null;
    if (this.state.dateWhithinSeason === false) {
      result = (
        <p>Your entry date falls outside the <b>quota season</b>. Contact the Inyo National Forest office for more details on the best way to acquire a permit.</p>
      );
    }
    else if (this.state.moreThankSixMonthAway === true) {
      result = (
        <p>The date <b>{this.state.date.format('l')}</b> is not available yet. Return to this site when it is six months before your trip.</p>
      );
    }

    let resultExplanaion = null;
    switch (this.props.result) {
      case QUESTIONAIRE_RESULTS_ENUM.INYO_OVERNIGHT_PERMIT:

        resultExplanaion = (
          <p>
            You will need an Inyo National Forest Overnight Permit for the date and entry point where you will be starting your trip.
            <br />
            <b>NOTE</b> – you do not need a permit if you are not staying overnight
          </p>
        );
        break;
      case QUESTIONAIRE_RESULTS_ENUM.INYO_OVERNIGHT_PERMIT_2:
        resultExplanaion = (
          <div>
            <p>You will need an Inyo National Forest Overnight Permit for the date and entry point where you will be starting your trip.</p>
            <p><b>However,</b> it is not part of the Mt. Whitney lottery.</p>
          </div>);
        break;
      default:
        resultExplanaion = null;
    }
    return (
      <div>
        <h3 className="rec-questionnaire-result-what-you-need">You will need a...</h3>
        <div className="rec-questionnaire-result-title">
          Overnight Permit
      </div>

        <div className="rec-questionnaire-result-icon">
          <Icons.IconPermit />
        </div>
        <div>
          {resultExplanaion}
        </div>

        <div className="rec-form-item-wrap">
          <label htmlFor="SingleDatePicker2">
            Desired entry date
            <SingleDatePicker id="date"{...this.getSingleDatePickerFormElementProps()} />
          </label>
        </div>

        <div className="rec-grid-12-12">
          {result}
          <Button
            className="rec-button-primary"
            title="check availability"
            onClick={this.setPermitType}
            disabled={this.state.isDisabled}
            aria-label="check availability">
            Check Availability
          </Button>
        </div>
      </div>
    );
  }
}

InyoNFOvernightPermit.propTypes = {
  history: TYPES.HISTORY,
  pActions: PropTypes.object.isRequired,
  permit: PropTypes.object.isRequired,
  result: PropTypes.string.isRequired
};

export default withRouter(InyoNFOvernightPermit);
